import { render, staticRenderFns } from "./TrApprovedModal.vue?vue&type=template&id=4ee3921a"
import script from "./trApprovedModal.ts?vue&type=script&lang=ts&external"
export * from "./trApprovedModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports